/* eslint-disable better-mutation/no-mutation */

import Axios from 'axios';
import { isServer } from 'tradera/utils/nextjs';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation is not compatible with SSR as global properties are shared between server instances'
    );
}

(function (w) {
    if (!w) {
        return;
    }
    let saved = null;
    let savedListener = null;
    w.onFacebookNativeLogin = (err, data) => {
        if (savedListener) {
            savedListener(err, data);
        } else {
            saved = { err: err, data: data };
        }
    };
    w.onFacebookNativeLoginSetListener = (listener) => {
        savedListener = listener;
        if (saved) {
            savedListener(saved.err, saved.data);
            saved = null;
        }
    };
})(window);

export default class FacebookLogin {
    constructor(facebookAppId) {
        !facebookAppId &&
            console.error('FacebookLogin.appId is required but was empty');
        this.appId = facebookAppId;
        this.userId = null;
        this.firstName = null;
    }

    isLoaded() {
        return window.FB && !!window.FB.init;
    }

    onNativeInitiatedLogin(callback) {
        const w = window;
        if (!w) {
            return;
        }
        w.onFacebookNativeLoginSetListener((err, data) => {
            if (err) {
                console.error(
                    'Facebook Native Initiated login failed',
                    err,
                    data
                );
                this._save(null);
            } else {
                data.userId = data.userID;
                this._save(data);
                callback(data);
            }
        });
    }

    login(options = { native: false }) {
        const w = window;
        if (w && options.native) {
            return new Promise((resolve, reject) => {
                w.onFacebookNativeLoginSetListener((err, data) => {
                    if (err || !data) {
                        console.error(
                            'Facebook Native login failed',
                            err,
                            data
                        );
                        this._save(null);
                        reject(err ? err : 'Aborted');
                    } else {
                        data.userId = data.userID;
                        this._save(data);
                        resolve(data);
                    }
                });
                w.document.location.href =
                    'tradera://register/facebook?callbackFunc=onFacebookNativeLogin';
            });
        } else {
            window.FB.init({
                appId: this.appId,
                version: 'v3.3'
            });

            return new Promise((resolve, reject) => {
                window.FB.login(this._onLogin(resolve, reject), {
                    scope: 'public_profile,email',
                    auth_type: 'rerequest'
                });
            });
        }
    }

    _save(data) {
        if (!data) {
            this.userId = null;
            this.firstName = null;
        } else {
            this.userId = data.userID;
            this.firstName = data.firstName;
            this.lastName = data.lastName;
        }
    }

    _onLogin(resolve, reject) {
        return (loginData) => {
            if (loginData.status !== 'connected') {
                // User pressed cancel in facebook popup. Login unsuccessful
                return reject();
            }
            window.FB.api(
                '/me?fields=email,first_name,last_name,link',
                'get',
                null,
                (profileData) => {
                    Axios.post('/register/api/facebook', {
                        id: loginData.authResponse.userID,
                        token: loginData.authResponse.accessToken
                    })
                        .then(() => {
                            const data = {
                                accessToken: loginData.authResponse.accessToken,
                                userId: loginData.authResponse.userID,
                                email: profileData.email,
                                firstName: profileData.first_name,
                                lastName: profileData.last_name
                            };
                            this._save(data);
                            resolve(data);
                            return;
                        })
                        .catch((err) => {
                            console.error(err);
                            this._save(null);
                            reject(err);
                        });
                }
            );
        };
    }
}
